import type { IAuthRepository } from '../../domain/repositories/IAuthRepository';
import { RemoteAuthRepository } from './RemoteAuthRepository';

let instance: IAuthRepository | null = null;

export function getAuthRepository(): IAuthRepository {
  if (!instance) {
    instance = new RemoteAuthRepository();
  }
  return instance;
}
